<div class="topbar-container">
  <!-- Left Section -->
  <div class="topbar-left">
    <!-- Mobile Menu Toggle -->
    <button
      *ngIf="isMobile"
      type="button"
      class="menu-toggle"
      pButton
      pRipple
      icon="pi pi-bars"
      [text]="true"
      (click)="onMenuToggle()">
    </button>

    <!-- Page Title and Date -->
    <div class="page-info">
  <h1 class="page-title">{{ 'layout.topbar.dashboardTitle' | transloco }}</h1>
      <p class="page-date">{{ formattedDate }}</p>
    </div>
  </div>

  <!-- Right Section -->
  <div class="topbar-right">
    <!-- Search -->
    <div class="search-container" *ngIf="!isMobile">
      <p-inputgroup>
        <input
          pInputText
          placeholder="{{ 'layout.topbar.searchPlaceholder' | transloco }}"
          [(ngModel)]="searchValue"
          (keyup.enter)="onSearch()"
          styleClass="w-20rem" />
        <p-inputgroup-addon>
          <p-button
            icon="pi pi-search"
            severity="secondary"
            variant="text"
            (click)="onSearch()" />
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>

    <!-- Search Icon for Mobile -->
    <button
      *ngIf="isMobile"
      type="button"
      class="action-button"
      pButton
      pRipple
      icon="pi pi-search"
      [text]="true"
      (click)="onSearch()">
    </button>

    <!-- Notifications -->
    <div class="notification-wrapper">
      <button
        type="button"
        class="action-button"
        pButton
        pRipple
        icon="pi pi-bell"
        [text]="true"
        pBadge
        [value]="notificationCount"
        badgeClass="notification-badge"
        (click)="onNotificationClick()">
      </button>
    </div>

    <!-- Eye Icon (from design) -->
    <button
      type="button"
      class="action-button"
      pButton
      pRipple
      icon="pi pi-eye"
      [text]="true">
    </button>
  </div>
</div>
